export const maintenanceHistoryFieldConfiguration = [
  {
    name: "dateFullfilled",
    label: "Date",
    type: "text",
    validation: {
      required: "Date is required",
      pattern: {
        value: /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12]\d|3[01])\/(19|20)\d{2}$/,
        message: "Date must be in the format MM/DD/YYYY",
      },
    },
  },
  {
    name: "mileage",
    label: "Mileage",
    type: "text",
    validation: {
      required: "Mileage is required",
      pattern: {
        value: /^[0-9]*\.?[0-9]*$/,
        message: "Mileage must be a number",
      },
    },
  },
  {
    name: "engineHours",
    label: "Engine hours",
    type: "text",
    validation: {
      required: "Engine hours are required",
      pattern: {
        value: /^[0-9]*\.?[0-9]*$/,
        message: "Mileage must be a number",
      },
    },
  },
  {
    name: "notes",
    label: "Notes",
    type: "text",
    validation: {
      required: "Notes are required",
      minLength: { value: 2, message: "Minimum length is 2 characters" },
      maxLength: { value: 100, message: "Maximum length is 100 characters" },
    },
  },
];
